Customer.Users ||= {}

class Customer.Users.ProfileDescriptionView extends Backbone.View
  template: JST['backbone/templates/customer/users/profile_description']
  id: 'profile-description'

  events:
    'click #save-description': 'onClickSave'
    'click .profile-description-box': 'onClickBox'
    'keyup .profile-description-box': 'onEdit'

  initialize: (@options = {}) ->
    @profile = @options.profile
    @currentDescription = @profile.description || ''
    @profileDescriptionPlaceholder = @options.profileDescriptionPlaceholder

  render: ->
    @$el.html(@template(profileDescriptionPlaceholder: @profileDescriptionPlaceholder))
    @$el.find('.profile-description-box').val(@currentDescription)
    @updateSaveButtonStatus()

    return this

  editModeOn: ->
    @$el.find('.profile-description-box').attr("readonly", false)
    @$el.find('.profile-description-box').css("border", "1px solid #cccccc")
    @$el.find('.profile-description-box').css("cursor", "text")
    @$el.find('.profile-description-options').show()

  editModeOff: ->
    @$el.find('.profile-description-box').attr("readonly", true)
    @$el.find('.profile-description-box').css("border", "none")
    @$el.find('.profile-description-box').css("cursor", "default")
    @$el.find('.profile-description-options').hide()

  onEdit: (event) =>
    @updateSaveButtonStatus()

  updateSaveButtonStatus: ->
    canSave = @currentDescription.trim() != (@$el.find('.profile-description-box').val() || '').trim()
    buttonSave = @$el.find('#save-description')
    if canSave
      buttonSave.attr("disabled", false).removeClass("ui-state-disabled")
    else
      buttonSave.attr("disabled", true).addClass("ui-state-disabled")

  onClickBox: ->
    unless @$el.find('.profile-description-save-status').hasClass('processing-small')
      @$el.find('.profile-description-save-status span').text('')

  onClickSave: ->
    @$el.find('.profile-description-save-status span').text('Saving...')
    @$el.find('.profile-description-save-status').addClass('processing-small')
    @previousDescription = @currentDescription
    @currentDescription = @$el.find('.profile-description-box').val()
    @updateSaveButtonStatus()
    data = { profile_id: @profile.id, profile_description: @currentDescription }
    $('#main-profile-preview').find('.profile-description-box').val(@currentDescription)
    $.ajax
      type: 'POST'
      url: "/profiles/api/update"
      data: data
      success: @showSuccess
      error: @showError

  showSuccess: =>
    @$el.find('.profile-description-save-status').removeClass('processing-small')
    @$el.find('.profile-description-save-status span').text('Saved!')
    @updateSaveButtonStatus()

  showError: =>
    @$el.find('.profile-description-save-status').removeClass('processing-small')
    @$el.find('.profile-description-save-status span').val('An error has occurred, please try again')
    @currentDescription = @previousDescription
    @updateSaveButtonStatus()